import * as Types from '../../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FlowStateUpdateFragmentFragmentDoc } from '../generated';
export type CustomerForAddressStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null } };

export type CustomerForAddressStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForAddressStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null } } };

export type UpdateCustomerForAddressStepMutationVariables = Types.Exact<{
  address: Types.AddressInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForAddressStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type GetCustomerForBasicInfoStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForBasicInfoStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, acceptedDreamboundTerms: boolean | null }, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null } | null } };

export type GetProgramForBasicInfoStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type GetProgramForBasicInfoStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, provider: { __typename?: 'Provider', id: string, isPartnered: boolean, marketplaceConfig: { __typename?: 'ProviderMarketplaceConfig', id: string, programFlowEmailStepHeader: string | null, programFlowBasicInfoStepHeader: string | null, programFlowHeadsUpPhoneDisclaimer: string | null } } } };

export type CreateUserAndEnrollmentForBasicInfoStepMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateUserAndEnrollmentForBasicInfoStepMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, phone: string | null, email: string | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } | null };

export type UpdateCustomerForBasicInfoStepMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
  shouldGetTokens: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForBasicInfoStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, acceptedDreamboundTerms: boolean | null, acceptedTermsVersion: Types.AcceptedTermsVersion | null }, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null, tokens?: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForCareerAspectsDesiredStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsDesired: string | null } };

export type GetCustomerForCareerAspectsDesiredStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForCareerAspectsDesiredStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsDesired: string | null } } };

export type UpdateCustomerQuestionnaireForCareerAspectsDesiredStepMutationVariables = Types.Exact<{
  careerAspectsDesired: Types.Scalars['String']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForCareerAspectsDesiredStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsDesired: string | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForCareerAspectsRankingStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsRanking: Array<Types.CareerAspect> | null } };

export type GetCustomerForCareerAspectsRankingStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForCareerAspectsRankingStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsRanking: Array<Types.CareerAspect> | null } } };

export type UpdateCustomerQuestionnaireForCareerAspectsRankingStepMutationVariables = Types.Exact<{
  careerAspectsRanking?: Types.InputMaybe<Array<Types.CareerAspect>>;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForCareerAspectsRankingStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerAspectsRanking: Array<Types.CareerAspect> | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForCareerChangeConcernStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerChangeConcern: Types.CareerChangeConcern | null } };

export type GetCustomerForCareerChangeConcernStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForCareerChangeConcernStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerChangeConcern: Types.CareerChangeConcern | null } } };

export type UpdateCustomerQuestionnaireForCareerChangeConcernStepMutationVariables = Types.Exact<{
  careerChangeConcern: Types.CareerChangeConcern;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForCareerChangeConcernStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerChangeConcern: Types.CareerChangeConcern | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForCareerGoalStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerGoal: Types.CareerGoal | null } };

export type GetCustomerForCareerGoalStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForCareerGoalStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerGoal: Types.CareerGoal | null } } };

export type UpdateCustomerQuestionnaireForCareerGoalStepMutationVariables = Types.Exact<{
  careerGoal: Types.CareerGoal;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForCareerGoalStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerGoal: Types.CareerGoal | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForCareerTimelineStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerTimeline: Types.CareerTimeline | null } };

export type GetCustomerForCareerTimelineStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForCareerTimelineStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerTimeline: Types.CareerTimeline | null } } };

export type UpdateCustomerQuestionnaireForCareerTimelineStepMutationVariables = Types.Exact<{
  careerTimeline: Types.CareerTimeline;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForCareerTimelineStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, careerTimeline: Types.CareerTimeline | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type ProgramForConfirmStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForConfirmStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, customCtaCopy: string | null, customDisclaimer: string | null, leadRedirect: string | null, provider: { __typename?: 'Provider', id: string, shortName: string, fullName: string, advertiserName: string | null, isTrustedFormEnabled: boolean } } };

export type CustomerForConfirmStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type CustomerForConfirmStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } };

export type UpdateCustomerAndCreateLeadForConfirmStepMutationVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
  customerData?: Types.InputMaybe<Types.CustomerUpdateInput>;
  jornayaLeadId: Types.Scalars['String']['input'];
  trustedFormCertId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  disclaimer?: Types.InputMaybe<Types.Scalars['String']['input']>;
  programFlow: Types.Scalars['Boolean']['input'];
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
  funnelId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  tracking?: Types.InputMaybe<Types.EverflowTrackingInput>;
}>;


export type UpdateCustomerAndCreateLeadForConfirmStepMutation = { __typename?: 'Mutation', createOrUpdateIntakeEnrollment: { __typename?: 'EnrollmentItem', id: string, status: Types.EnrollmentStatus, formFunnelInfo: { __typename?: 'FormFunnelInfo', id: string } | null, customer: { __typename?: 'Customer', id: string, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } };

export type GetProgramForCustomerEligibilityStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetProgramForCustomerEligibilityStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, name: string, customCtaCopy: string | null, customDisclaimer: string | null, dobFieldVisibility: Types.DobFieldVisibility, hsGradYearMin: number | null, hsGradYearMax: number | null, provider: { __typename?: 'Provider', id: string, shortName: string, fullName: string, advertiserName: string | null, isTrustedFormEnabled: boolean } } };

export type CustomerForCustomerEligibilityStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  programId: Types.Scalars['ID']['input'];
}>;


export type CustomerForCustomerEligibilityStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, missingRequiredFields: Array<Types.ProgramRequiredField>, detailsMap: { __typename?: 'CustomerDetailMap', id: string, dob: string | null, educationLevel: Types.EducationLevel | null, isUsCitizen: boolean | null, graduatedHighSchoolIn: string | null, hasRNLicense: boolean | null, hasMilitaryAffiliation: boolean | null, address: { __typename?: 'AddressWithZip', id: string, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null } } };

export type GetPennFosterHighSchoolProgramForCustomerEligibilityStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetPennFosterHighSchoolProgramForCustomerEligibilityStepQuery = { __typename?: 'Query', programBySlugs: { __typename?: 'Program', id: string, preLeadRedirect: string | null, preLeadRedirectParams: {
      [key: string]: any;
    } | null } };

export type UpdateCustomerAndCreateLeadForCustomerEligibilityStepMutationVariables = Types.Exact<{
  customerData?: Types.InputMaybe<Types.CustomerUpdateInput>;
  programId: Types.Scalars['ID']['input'];
  jornayaLeadId: Types.Scalars['String']['input'];
  trustedFormCertId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  disclaimer?: Types.InputMaybe<Types.Scalars['String']['input']>;
  programFlow: Types.Scalars['Boolean']['input'];
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
  funnelId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  tracking?: Types.InputMaybe<Types.EverflowTrackingInput>;
}>;


export type UpdateCustomerAndCreateLeadForCustomerEligibilityStepMutation = { __typename?: 'Mutation', createOrUpdateIntakeEnrollment: { __typename?: 'EnrollmentItem', id: string, status: Types.EnrollmentStatus, formFunnelInfo: { __typename?: 'FormFunnelInfo', id: string } | null, customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, dob: string | null, educationLevel: Types.EducationLevel | null, graduatedHighSchoolIn: string | null, address: { __typename?: 'AddressWithZip', id: string, street: string | null, street2: string | null, city: string | null, state: string | null, zip: string } | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } };

export type CustomerForDateOfBirthStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, dob: string | null } };

export type CustomerForDateOfBirthStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForDateOfBirthStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, dob: string | null } } };

export type ProgramForDateOfBirthStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForDateOfBirthStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, dobFieldVisibility: Types.DobFieldVisibility } };

export type UpdateCustomerForDateOfBirthStepMutationVariables = Types.Exact<{
  dob: Types.Scalars['ISODate']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForDateOfBirthStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, dob: string | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForDigDeeperPresentedStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, digDeeperPresented: boolean | null } };

export type GetCustomerForDigDeeperPresentedStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForDigDeeperPresentedStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, digDeeperPresented: boolean | null } } };

export type UpdateCustomerQuestionnaireForDigDeeperPresentedStepMutationVariables = Types.Exact<{
  digDeeperPresented: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForDigDeeperPresentedStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, digDeeperPresented: boolean | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type ProgramForDirectorySchoolConfirmationStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForDirectorySchoolConfirmationStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry } } };

export type PennFosterProgramForEducationLevelDisqualificationStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PennFosterProgramForEducationLevelDisqualificationStepQuery = { __typename?: 'Query', programBySlugs: { __typename?: 'Program', id: string, preLeadRedirect: string | null, preLeadRedirectParams: {
      [key: string]: any;
    } | null, allowHybridSignup: boolean } };

export type CustomerForEducationLevelStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, educationLevel: Types.EducationLevel | null } };

export type CustomerForEducationLevelStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForEducationLevelStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, educationLevel: Types.EducationLevel | null } } };

export type UpdateCustomerForEducationLevelStepMutationVariables = Types.Exact<{
  educationLevel: Types.EducationLevel;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForEducationLevelStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, educationLevel: Types.EducationLevel | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type GetProgramForEmailStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type GetProgramForEmailStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, provider: { __typename?: 'Provider', id: string, isPartnered: boolean, marketplaceConfig: { __typename?: 'ProviderMarketplaceConfig', id: string, programFlowEmailStepHeader: string | null, programFlowBasicInfoStepHeader: string | null, programFlowHeadsUpEmailDisclaimer: string | null }, publicAddress: { __typename?: 'AddressWithZip', zip: string } }, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry } } };

export type CreateUserAndEnrollmentForEmailStepMutationVariables = Types.Exact<{
  data: Types.CustomerAndEnrollmentItemCreateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateUserAndEnrollmentForEmailStepMutation = { __typename?: 'Mutation', createOneCustomer: { __typename?: 'CustomerAndEnrollmentItem', customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, email: string | null, emailVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } } | null };

export type UpdateCustomerForEmailStepMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForEmailStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, email: string | null, emailVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForEmailStepFragmentFragment = { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, email: string | null, emailVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null };

export type CustomerForHighSchoolGraduationYearStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, graduatedHighSchoolIn: string | null } };

export type CustomerForHighSchoolGraduationYearStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForHighSchoolGraduationYearStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, graduatedHighSchoolIn: string | null } } };

export type ProgramForHighSchoolGraduationYearStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForHighSchoolGraduationYearStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, hsGradYearMin: number | null, hsGradYearMax: number | null } };

export type UpdateCustomerForHighSchoolGraduationYearStepMutationVariables = Types.Exact<{
  graduatedHighSchoolIn: Types.Scalars['String']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForHighSchoolGraduationYearStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, graduatedHighSchoolIn: string | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForJobDislikeStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobDislike: string | null } };

export type GetCustomerForJobDislikeStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForJobDislikeStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobDislike: string | null } } };

export type UpdateCustomerQuestionnaireForJobDislikeStepMutationVariables = Types.Exact<{
  jobDislike: Types.Scalars['String']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForJobDislikeStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobDislike: string | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForJobEnjoymentStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobEnjoyment: string | null } };

export type GetCustomerForJobEnjoymentStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type GetCustomerForJobEnjoymentStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobEnjoyment: string | null } } };

export type UpdateCustomerQuestionnaireForJobEnjoymentStepMutationVariables = Types.Exact<{
  jobEnjoyment: Types.Scalars['String']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerQuestionnaireForJobEnjoymentStepMutation = { __typename?: 'Mutation', updateViewerCustomerQuestionnaire: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, jobEnjoyment: string | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForLeadBlockStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerForLeadBlockStepQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } | null };

export type ProgramForLeadBlockStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForLeadBlockStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, leadRedirect: string | null, provider: { __typename?: 'Provider', id: string, fullName: string }, vocation: { __typename?: 'Vocation', id: string, name: string, industry: Types.VocationIndustry } } };

export type ProgramForLeadRedirectStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForLeadRedirectStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, leadRedirect: string | null, provider: { __typename?: 'Provider', id: string, fullName: string } } };

export type CustomerForMilitaryAffiliationStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasMilitaryAffiliation: boolean | null } };

export type CustomerForMilitaryAffiliationStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForMilitaryAffiliationStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasMilitaryAffiliation: boolean | null } } };

export type UpdateCustomerForMilitaryAffiliationStepMutationVariables = Types.Exact<{
  hasMilitaryAffiliation: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForMilitaryAffiliationStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasMilitaryAffiliation: boolean | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type UpdateCustomerForPhoneStepMutationVariables = Types.Exact<{
  data: Types.CustomerUpdateInput;
  shouldGetTokens: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForPhoneStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null, tokens?: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string } } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type MeForPhoneVerificationStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeForPhoneVerificationStepQuery = { __typename?: 'Query', me: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null } };

export type RequestCodeViaPhoneForVerificationMutationVariables = Types.Exact<{
  phone: Types.Scalars['String']['input'];
  isMobile?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type RequestCodeViaPhoneForVerificationMutation = { __typename?: 'Mutation', requestCodeViaPhone: boolean | null };

export type VerifyPhoneCodeMutationVariables = Types.Exact<{
  code: Types.Scalars['String']['input'];
  phone: Types.Scalars['String']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type VerifyPhoneCodeMutation = { __typename?: 'Mutation', verifyPhoneCode: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null, tokens: { __typename?: 'ClientAuthToken', accessToken: string, refreshToken: string }, customer: { __typename?: 'Customer', id: string, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } };

export type ProgramForPreLeadRedirectStepQueryVariables = Types.Exact<{
  programId: Types.Scalars['ID']['input'];
}>;


export type ProgramForPreLeadRedirectStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, preLeadRedirect: string | null, preLeadRedirectParams: {
      [key: string]: any;
    } | null, provider: { __typename?: 'Provider', id: string, fullName: string } } };

export type ProgramForCompletedStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForCompletedStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, leadRedirect: string | null, vocation: { __typename?: 'Vocation', id: string, name: string, industry: Types.VocationIndustry }, provider: { __typename?: 'Provider', id: string, fullName: string, showPostLeadRecommendations: boolean } } };

export type CustomerForCompletedStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForCompletedStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } };

export type CustomerForRnLicenseStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasRNLicense: boolean | null } };

export type CustomerForRnLicenseStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForRnLicenseStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasRNLicense: boolean | null } } };

export type UpdateCustomerForRnLicenseStepMutationVariables = Types.Exact<{
  hasRNLicense: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForRnLicenseStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, hasRNLicense: boolean | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CreateUserSignInStepMutationVariables = Types.Exact<{
  data: Types.UserCreateInput;
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type CreateUserSignInStepMutation = { __typename?: 'Mutation', createOneUser: { __typename?: 'User', id: string, phone: string | null, phoneVerified: boolean | null, email: string | null, emailVerified: boolean | null, customer: { __typename?: 'Customer', id: string, user: { __typename?: 'User', id: string, nameFirst: string | null, nameLast: string | null, email: string | null, phone: string | null } | null, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null } | null };

export type CustomerForStateRestrictionRejectedStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerForStateRestrictionRejectedStepQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } | null };

export type ProgramForStateRestrictionRejectedStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForStateRestrictionRejectedStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry } } };

export type CustomerForStudentRejectedStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerForStudentRejectedStepQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } | null };

export type ProgramForStudentRejectedStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForStudentRejectedStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, provider: { __typename?: 'Provider', id: string, fullName: string }, vocation: { __typename?: 'Vocation', id: string, name: string, industry: Types.VocationIndustry } } };

export type CustomerForUsCitizenshipStepFragment = { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, isUsCitizen: boolean | null } };

export type CustomerForUsCitizenshipStepQueryVariables = Types.Exact<{
  customerId: Types.Scalars['ID']['input'];
}>;


export type CustomerForUsCitizenshipStepQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, isUsCitizen: boolean | null } } };

export type UpdateCustomerForUsCitizenshipStepMutationVariables = Types.Exact<{
  isUsCitizen: Types.Scalars['Boolean']['input'];
  programFlow: Types.Scalars['Boolean']['input'];
  programId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  questionnaireFlow: Types.Scalars['Boolean']['input'];
  skipperFlow: Types.Scalars['Boolean']['input'];
  flowIntent?: Types.InputMaybe<Types.FlowIntent>;
  signInFlow: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerForUsCitizenshipStepMutation = { __typename?: 'Mutation', updateViewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, isUsCitizen: boolean | null }, programFlow?: { __typename?: 'ProgramFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'ProgramFlowStep', id: string, name: Types.ProgramFlowStepName, status: Types.FlowStepStatus }> } | null, questionnaireFlow?: { __typename?: 'QuestionnaireFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'QuestionnaireFlowStep', id: string, name: Types.QuestionnaireFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, skipperFlow?: { __typename?: 'SkipperFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SkipperFlowStep', id: string, name: Types.SkipperFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null, signInFlow?: { __typename?: 'SignInFlowState', id: string, hasBlockingStep: boolean, initialStep: { __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus }, steps: Array<{ __typename?: 'SignInFlowStep', id: string, name: Types.SignInFlowStepName, status: Types.FlowStepStatus, isBlocking: boolean }> } | null } | null };

export type CustomerForZipCodeRestrictionStepQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CustomerForZipCodeRestrictionStepQuery = { __typename?: 'Query', viewerCustomer: { __typename?: 'Customer', id: string, detailsMap: { __typename?: 'CustomerDetailMap', id: string, address: { __typename?: 'AddressWithZip', id: string, zip: string } | null } } | null };

export type ProgramForZipCodeRestrictionStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ProgramForZipCodeRestrictionStepQuery = { __typename?: 'Query', program: { __typename?: 'Program', id: string, vocation: { __typename?: 'Vocation', id: string, industry: Types.VocationIndustry } } };

export const CustomerForAddressStepFragmentDoc = gql`
    fragment CustomerForAddressStep on Customer {
  id
  detailsMap {
    id
    address {
      id
      street
      street2
      city
      state
      zip
    }
  }
}
    ` as unknown as DocumentNode<CustomerForAddressStepFragment, unknown>;
export const CustomerForCareerAspectsDesiredStepFragmentDoc = gql`
    fragment CustomerForCareerAspectsDesiredStep on Customer {
  id
  detailsMap {
    id
    careerAspectsDesired
  }
}
    ` as unknown as DocumentNode<CustomerForCareerAspectsDesiredStepFragment, unknown>;
export const CustomerForCareerAspectsRankingStepFragmentDoc = gql`
    fragment CustomerForCareerAspectsRankingStep on Customer {
  id
  detailsMap {
    id
    careerAspectsRanking
  }
}
    ` as unknown as DocumentNode<CustomerForCareerAspectsRankingStepFragment, unknown>;
export const CustomerForCareerChangeConcernStepFragmentDoc = gql`
    fragment CustomerForCareerChangeConcernStep on Customer {
  id
  detailsMap {
    id
    careerChangeConcern
  }
}
    ` as unknown as DocumentNode<CustomerForCareerChangeConcernStepFragment, unknown>;
export const CustomerForCareerGoalStepFragmentDoc = gql`
    fragment CustomerForCareerGoalStep on Customer {
  id
  detailsMap {
    id
    careerGoal
  }
}
    ` as unknown as DocumentNode<CustomerForCareerGoalStepFragment, unknown>;
export const CustomerForCareerTimelineStepFragmentDoc = gql`
    fragment CustomerForCareerTimelineStep on Customer {
  id
  detailsMap {
    id
    careerTimeline
  }
}
    ` as unknown as DocumentNode<CustomerForCareerTimelineStepFragment, unknown>;
export const CustomerForDateOfBirthStepFragmentDoc = gql`
    fragment CustomerForDateOfBirthStep on Customer {
  id
  detailsMap {
    id
    dob
  }
}
    ` as unknown as DocumentNode<CustomerForDateOfBirthStepFragment, unknown>;
export const CustomerForDigDeeperPresentedStepFragmentDoc = gql`
    fragment CustomerForDigDeeperPresentedStep on Customer {
  id
  detailsMap {
    id
    digDeeperPresented
  }
}
    ` as unknown as DocumentNode<CustomerForDigDeeperPresentedStepFragment, unknown>;
export const CustomerForEducationLevelStepFragmentDoc = gql`
    fragment CustomerForEducationLevelStep on Customer {
  id
  detailsMap {
    id
    educationLevel
  }
}
    ` as unknown as DocumentNode<CustomerForEducationLevelStepFragment, unknown>;
export const CustomerForEmailStepFragmentFragmentDoc = gql`
    fragment CustomerForEmailStepFragment on Customer {
  id
  user {
    id
    email
    emailVerified
    tokens {
      accessToken
      refreshToken
    }
  }
}
    ` as unknown as DocumentNode<CustomerForEmailStepFragmentFragment, unknown>;
export const CustomerForHighSchoolGraduationYearStepFragmentDoc = gql`
    fragment CustomerForHighSchoolGraduationYearStep on Customer {
  id
  detailsMap {
    id
    graduatedHighSchoolIn
  }
}
    ` as unknown as DocumentNode<CustomerForHighSchoolGraduationYearStepFragment, unknown>;
export const CustomerForJobDislikeStepFragmentDoc = gql`
    fragment CustomerForJobDislikeStep on Customer {
  id
  detailsMap {
    id
    jobDislike
  }
}
    ` as unknown as DocumentNode<CustomerForJobDislikeStepFragment, unknown>;
export const CustomerForJobEnjoymentStepFragmentDoc = gql`
    fragment CustomerForJobEnjoymentStep on Customer {
  id
  detailsMap {
    id
    jobEnjoyment
  }
}
    ` as unknown as DocumentNode<CustomerForJobEnjoymentStepFragment, unknown>;
export const CustomerForMilitaryAffiliationStepFragmentDoc = gql`
    fragment CustomerForMilitaryAffiliationStep on Customer {
  id
  detailsMap {
    id
    hasMilitaryAffiliation
  }
}
    ` as unknown as DocumentNode<CustomerForMilitaryAffiliationStepFragment, unknown>;
export const CustomerForRnLicenseStepFragmentDoc = gql`
    fragment CustomerForRnLicenseStep on Customer {
  id
  detailsMap {
    id
    hasRNLicense
  }
}
    ` as unknown as DocumentNode<CustomerForRnLicenseStepFragment, unknown>;
export const CustomerForUsCitizenshipStepFragmentDoc = gql`
    fragment CustomerForUsCitizenshipStep on Customer {
  id
  detailsMap {
    id
    isUsCitizen
  }
}
    ` as unknown as DocumentNode<CustomerForUsCitizenshipStepFragment, unknown>;
export const CustomerForAddressStepDocument = gql`
    query customerForAddressStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForAddressStep
  }
}
    ${CustomerForAddressStepFragmentDoc}` as unknown as DocumentNode<CustomerForAddressStepQuery, CustomerForAddressStepQueryVariables>;
export const UpdateCustomerForAddressStepDocument = gql`
    mutation updateCustomerForAddressStep($address: AddressInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {address: $address}) {
    ...CustomerForAddressStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForAddressStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForAddressStepMutation, UpdateCustomerForAddressStepMutationVariables>;
export const GetCustomerForBasicInfoStepDocument = gql`
    query getCustomerForBasicInfoStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    id
    detailsMap {
      id
      acceptedDreamboundTerms
    }
    user {
      id
      nameFirst
      nameLast
      phone
      email
    }
  }
}
    ` as unknown as DocumentNode<GetCustomerForBasicInfoStepQuery, GetCustomerForBasicInfoStepQueryVariables>;
export const GetProgramForBasicInfoStepDocument = gql`
    query getProgramForBasicInfoStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    provider {
      id
      isPartnered
      marketplaceConfig {
        id
        programFlowEmailStepHeader
        programFlowBasicInfoStepHeader
        programFlowHeadsUpPhoneDisclaimer
      }
    }
  }
}
    ` as unknown as DocumentNode<GetProgramForBasicInfoStepQuery, GetProgramForBasicInfoStepQueryVariables>;
export const CreateUserAndEnrollmentForBasicInfoStepDocument = gql`
    mutation createUserAndEnrollmentForBasicInfoStep($data: CustomerAndEnrollmentItemCreateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneCustomer(data: $data) {
    customer {
      id
      user {
        id
        nameFirst
        nameLast
        phone
        email
        tokens {
          accessToken
          refreshToken
        }
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateUserAndEnrollmentForBasicInfoStepMutation, CreateUserAndEnrollmentForBasicInfoStepMutationVariables>;
export const UpdateCustomerForBasicInfoStepDocument = gql`
    mutation updateCustomerForBasicInfoStep($data: CustomerUpdateInput!, $shouldGetTokens: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: $data) {
    id
    detailsMap {
      id
      acceptedDreamboundTerms
      acceptedTermsVersion
    }
    user {
      id
      nameFirst
      nameLast
      email
      phone
      tokens @include(if: $shouldGetTokens) {
        accessToken
        refreshToken
      }
    }
    ...FlowStateUpdateFragment
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForBasicInfoStepMutation, UpdateCustomerForBasicInfoStepMutationVariables>;
export const GetCustomerForCareerAspectsDesiredStepDocument = gql`
    query getCustomerForCareerAspectsDesiredStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForCareerAspectsDesiredStep
  }
}
    ${CustomerForCareerAspectsDesiredStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForCareerAspectsDesiredStepQuery, GetCustomerForCareerAspectsDesiredStepQueryVariables>;
export const UpdateCustomerQuestionnaireForCareerAspectsDesiredStepDocument = gql`
    mutation updateCustomerQuestionnaireForCareerAspectsDesiredStep($careerAspectsDesired: String!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(
    data: {careerAspectsDesired: $careerAspectsDesired}
  ) {
    ...CustomerForCareerAspectsDesiredStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForCareerAspectsDesiredStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForCareerAspectsDesiredStepMutation, UpdateCustomerQuestionnaireForCareerAspectsDesiredStepMutationVariables>;
export const GetCustomerForCareerAspectsRankingStepDocument = gql`
    query getCustomerForCareerAspectsRankingStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForCareerAspectsRankingStep
  }
}
    ${CustomerForCareerAspectsRankingStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForCareerAspectsRankingStepQuery, GetCustomerForCareerAspectsRankingStepQueryVariables>;
export const UpdateCustomerQuestionnaireForCareerAspectsRankingStepDocument = gql`
    mutation updateCustomerQuestionnaireForCareerAspectsRankingStep($careerAspectsRanking: [CareerAspect!], $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(
    data: {careerAspectsRanking: $careerAspectsRanking}
  ) {
    ...CustomerForCareerAspectsRankingStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForCareerAspectsRankingStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForCareerAspectsRankingStepMutation, UpdateCustomerQuestionnaireForCareerAspectsRankingStepMutationVariables>;
export const GetCustomerForCareerChangeConcernStepDocument = gql`
    query getCustomerForCareerChangeConcernStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForCareerChangeConcernStep
  }
}
    ${CustomerForCareerChangeConcernStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForCareerChangeConcernStepQuery, GetCustomerForCareerChangeConcernStepQueryVariables>;
export const UpdateCustomerQuestionnaireForCareerChangeConcernStepDocument = gql`
    mutation updateCustomerQuestionnaireForCareerChangeConcernStep($careerChangeConcern: CareerChangeConcern!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(
    data: {careerChangeConcern: $careerChangeConcern}
  ) {
    ...CustomerForCareerChangeConcernStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForCareerChangeConcernStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForCareerChangeConcernStepMutation, UpdateCustomerQuestionnaireForCareerChangeConcernStepMutationVariables>;
export const GetCustomerForCareerGoalStepDocument = gql`
    query getCustomerForCareerGoalStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForCareerGoalStep
  }
}
    ${CustomerForCareerGoalStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForCareerGoalStepQuery, GetCustomerForCareerGoalStepQueryVariables>;
export const UpdateCustomerQuestionnaireForCareerGoalStepDocument = gql`
    mutation updateCustomerQuestionnaireForCareerGoalStep($careerGoal: CareerGoal!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(data: {careerGoal: $careerGoal}) {
    ...CustomerForCareerGoalStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForCareerGoalStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForCareerGoalStepMutation, UpdateCustomerQuestionnaireForCareerGoalStepMutationVariables>;
export const GetCustomerForCareerTimelineStepDocument = gql`
    query getCustomerForCareerTimelineStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForCareerTimelineStep
  }
}
    ${CustomerForCareerTimelineStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForCareerTimelineStepQuery, GetCustomerForCareerTimelineStepQueryVariables>;
export const UpdateCustomerQuestionnaireForCareerTimelineStepDocument = gql`
    mutation updateCustomerQuestionnaireForCareerTimelineStep($careerTimeline: CareerTimeline!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(data: {careerTimeline: $careerTimeline}) {
    ...CustomerForCareerTimelineStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForCareerTimelineStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForCareerTimelineStepMutation, UpdateCustomerQuestionnaireForCareerTimelineStepMutationVariables>;
export const ProgramForConfirmStepDocument = gql`
    query programForConfirmStep($id: ID!) {
  program(where: {id: $id}) {
    id
    name
    customCtaCopy
    customDisclaimer
    leadRedirect
    provider {
      id
      shortName
      fullName
      advertiserName
      isTrustedFormEnabled
    }
  }
}
    ` as unknown as DocumentNode<ProgramForConfirmStepQuery, ProgramForConfirmStepQueryVariables>;
export const CustomerForConfirmStepDocument = gql`
    query customerForConfirmStep($id: ID!) {
  customer(where: {id: $id}) {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForConfirmStepQuery, CustomerForConfirmStepQueryVariables>;
export const UpdateCustomerAndCreateLeadForConfirmStepDocument = gql`
    mutation updateCustomerAndCreateLeadForConfirmStep($programId: ID!, $customerData: CustomerUpdateInput, $jornayaLeadId: String!, $trustedFormCertId: String, $disclaimer: String, $programFlow: Boolean!, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!, $funnelId: String, $tracking: EverflowTrackingInput) {
  createOrUpdateIntakeEnrollment(
    programId: $programId
    customerData: $customerData
    jornayaLeadId: $jornayaLeadId
    trustedFormCertId: $trustedFormCertId
    disclaimer: $disclaimer
    createAsLead: true
    funnelId: $funnelId
    tracking: $tracking
  ) {
    id
    status
    formFunnelInfo {
      id
    }
    customer {
      id
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerAndCreateLeadForConfirmStepMutation, UpdateCustomerAndCreateLeadForConfirmStepMutationVariables>;
export const GetProgramForCustomerEligibilityStepDocument = gql`
    query getProgramForCustomerEligibilityStep($id: ID!) {
  program(where: {id: $id}) {
    id
    name
    customCtaCopy
    customDisclaimer
    dobFieldVisibility
    hsGradYearMin
    hsGradYearMax
    provider {
      id
      shortName
      fullName
      advertiserName
      isTrustedFormEnabled
    }
  }
}
    ` as unknown as DocumentNode<GetProgramForCustomerEligibilityStepQuery, GetProgramForCustomerEligibilityStepQueryVariables>;
export const CustomerForCustomerEligibilityStepDocument = gql`
    query customerForCustomerEligibilityStep($id: ID!, $programId: ID!) {
  customer(where: {id: $id}) {
    id
    missingRequiredFields(programId: $programId)
    detailsMap {
      id
      address {
        id
        street
        street2
        city
        state
        zip
      }
      dob
      educationLevel
      isUsCitizen
      graduatedHighSchoolIn
      hasRNLicense
      hasMilitaryAffiliation
    }
  }
}
    ` as unknown as DocumentNode<CustomerForCustomerEligibilityStepQuery, CustomerForCustomerEligibilityStepQueryVariables>;
export const GetPennFosterHighSchoolProgramForCustomerEligibilityStepDocument = gql`
    query getPennFosterHighSchoolProgramForCustomerEligibilityStep {
  programBySlugs(
    slugs: {providerSlug: "penn-foster", programSlug: "highschool-diploma"}
  ) {
    id
    preLeadRedirect
    preLeadRedirectParams
  }
}
    ` as unknown as DocumentNode<GetPennFosterHighSchoolProgramForCustomerEligibilityStepQuery, GetPennFosterHighSchoolProgramForCustomerEligibilityStepQueryVariables>;
export const UpdateCustomerAndCreateLeadForCustomerEligibilityStepDocument = gql`
    mutation updateCustomerAndCreateLeadForCustomerEligibilityStep($customerData: CustomerUpdateInput, $programId: ID!, $jornayaLeadId: String!, $trustedFormCertId: String, $disclaimer: String, $programFlow: Boolean!, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!, $funnelId: String, $tracking: EverflowTrackingInput) {
  createOrUpdateIntakeEnrollment(
    customerData: $customerData
    programId: $programId
    jornayaLeadId: $jornayaLeadId
    trustedFormCertId: $trustedFormCertId
    disclaimer: $disclaimer
    createAsLead: true
    funnelId: $funnelId
    tracking: $tracking
  ) {
    id
    status
    formFunnelInfo {
      id
    }
    customer {
      id
      detailsMap {
        id
        address {
          id
          street
          street2
          city
          state
          zip
        }
        dob
        educationLevel
        graduatedHighSchoolIn
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerAndCreateLeadForCustomerEligibilityStepMutation, UpdateCustomerAndCreateLeadForCustomerEligibilityStepMutationVariables>;
export const CustomerForDateOfBirthStepDocument = gql`
    query customerForDateOfBirthStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForDateOfBirthStep
  }
}
    ${CustomerForDateOfBirthStepFragmentDoc}` as unknown as DocumentNode<CustomerForDateOfBirthStepQuery, CustomerForDateOfBirthStepQueryVariables>;
export const ProgramForDateOfBirthStepDocument = gql`
    query programForDateOfBirthStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    dobFieldVisibility
  }
}
    ` as unknown as DocumentNode<ProgramForDateOfBirthStepQuery, ProgramForDateOfBirthStepQueryVariables>;
export const UpdateCustomerForDateOfBirthStepDocument = gql`
    mutation updateCustomerForDateOfBirthStep($dob: ISODate!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {dob: $dob}) {
    ...CustomerForDateOfBirthStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForDateOfBirthStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForDateOfBirthStepMutation, UpdateCustomerForDateOfBirthStepMutationVariables>;
export const GetCustomerForDigDeeperPresentedStepDocument = gql`
    query getCustomerForDigDeeperPresentedStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForDigDeeperPresentedStep
  }
}
    ${CustomerForDigDeeperPresentedStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForDigDeeperPresentedStepQuery, GetCustomerForDigDeeperPresentedStepQueryVariables>;
export const UpdateCustomerQuestionnaireForDigDeeperPresentedStepDocument = gql`
    mutation updateCustomerQuestionnaireForDigDeeperPresentedStep($digDeeperPresented: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(
    data: {digDeeperPresented: $digDeeperPresented}
  ) {
    ...CustomerForDigDeeperPresentedStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForDigDeeperPresentedStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForDigDeeperPresentedStepMutation, UpdateCustomerQuestionnaireForDigDeeperPresentedStepMutationVariables>;
export const ProgramForDirectorySchoolConfirmationStepDocument = gql`
    query programForDirectorySchoolConfirmationStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    vocation {
      id
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForDirectorySchoolConfirmationStepQuery, ProgramForDirectorySchoolConfirmationStepQueryVariables>;
export const PennFosterProgramForEducationLevelDisqualificationStepDocument = gql`
    query pennFosterProgramForEducationLevelDisqualificationStep {
  programBySlugs(
    slugs: {providerSlug: "penn-foster", programSlug: "highschool-diploma"}
  ) {
    id
    preLeadRedirect
    preLeadRedirectParams
    allowHybridSignup
  }
}
    ` as unknown as DocumentNode<PennFosterProgramForEducationLevelDisqualificationStepQuery, PennFosterProgramForEducationLevelDisqualificationStepQueryVariables>;
export const CustomerForEducationLevelStepDocument = gql`
    query customerForEducationLevelStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForEducationLevelStep
  }
}
    ${CustomerForEducationLevelStepFragmentDoc}` as unknown as DocumentNode<CustomerForEducationLevelStepQuery, CustomerForEducationLevelStepQueryVariables>;
export const UpdateCustomerForEducationLevelStepDocument = gql`
    mutation updateCustomerForEducationLevelStep($educationLevel: EducationLevel!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {educationLevel: $educationLevel}) {
    ...CustomerForEducationLevelStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForEducationLevelStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForEducationLevelStepMutation, UpdateCustomerForEducationLevelStepMutationVariables>;
export const GetProgramForEmailStepDocument = gql`
    query getProgramForEmailStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    provider {
      id
      isPartnered
      marketplaceConfig {
        id
        programFlowEmailStepHeader
        programFlowBasicInfoStepHeader
        programFlowHeadsUpEmailDisclaimer
      }
      publicAddress {
        zip
      }
    }
    vocation {
      id
      industry
    }
  }
}
    ` as unknown as DocumentNode<GetProgramForEmailStepQuery, GetProgramForEmailStepQueryVariables>;
export const CreateUserAndEnrollmentForEmailStepDocument = gql`
    mutation createUserAndEnrollmentForEmailStep($data: CustomerAndEnrollmentItemCreateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneCustomer(data: $data) {
    customer {
      ...CustomerForEmailStepFragment
      ...FlowStateUpdateFragment
    }
  }
}
    ${CustomerForEmailStepFragmentFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateUserAndEnrollmentForEmailStepMutation, CreateUserAndEnrollmentForEmailStepMutationVariables>;
export const UpdateCustomerForEmailStepDocument = gql`
    mutation updateCustomerForEmailStep($data: CustomerUpdateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: $data) {
    ...CustomerForEmailStepFragment
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForEmailStepFragmentFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForEmailStepMutation, UpdateCustomerForEmailStepMutationVariables>;
export const CustomerForHighSchoolGraduationYearStepDocument = gql`
    query customerForHighSchoolGraduationYearStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForHighSchoolGraduationYearStep
  }
}
    ${CustomerForHighSchoolGraduationYearStepFragmentDoc}` as unknown as DocumentNode<CustomerForHighSchoolGraduationYearStepQuery, CustomerForHighSchoolGraduationYearStepQueryVariables>;
export const ProgramForHighSchoolGraduationYearStepDocument = gql`
    query programForHighSchoolGraduationYearStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    hsGradYearMin
    hsGradYearMax
  }
}
    ` as unknown as DocumentNode<ProgramForHighSchoolGraduationYearStepQuery, ProgramForHighSchoolGraduationYearStepQueryVariables>;
export const UpdateCustomerForHighSchoolGraduationYearStepDocument = gql`
    mutation updateCustomerForHighSchoolGraduationYearStep($graduatedHighSchoolIn: String!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {graduatedHighSchoolIn: $graduatedHighSchoolIn}) {
    ...CustomerForHighSchoolGraduationYearStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForHighSchoolGraduationYearStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForHighSchoolGraduationYearStepMutation, UpdateCustomerForHighSchoolGraduationYearStepMutationVariables>;
export const GetCustomerForJobDislikeStepDocument = gql`
    query getCustomerForJobDislikeStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForJobDislikeStep
  }
}
    ${CustomerForJobDislikeStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForJobDislikeStepQuery, GetCustomerForJobDislikeStepQueryVariables>;
export const UpdateCustomerQuestionnaireForJobDislikeStepDocument = gql`
    mutation updateCustomerQuestionnaireForJobDislikeStep($jobDislike: String!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(data: {jobDislike: $jobDislike}) {
    ...CustomerForJobDislikeStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForJobDislikeStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForJobDislikeStepMutation, UpdateCustomerQuestionnaireForJobDislikeStepMutationVariables>;
export const GetCustomerForJobEnjoymentStepDocument = gql`
    query getCustomerForJobEnjoymentStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForJobEnjoymentStep
  }
}
    ${CustomerForJobEnjoymentStepFragmentDoc}` as unknown as DocumentNode<GetCustomerForJobEnjoymentStepQuery, GetCustomerForJobEnjoymentStepQueryVariables>;
export const UpdateCustomerQuestionnaireForJobEnjoymentStepDocument = gql`
    mutation updateCustomerQuestionnaireForJobEnjoymentStep($jobEnjoyment: String!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomerQuestionnaire(data: {jobEnjoyment: $jobEnjoyment}) {
    ...CustomerForJobEnjoymentStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForJobEnjoymentStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerQuestionnaireForJobEnjoymentStepMutation, UpdateCustomerQuestionnaireForJobEnjoymentStepMutationVariables>;
export const CustomerForLeadBlockStepDocument = gql`
    query customerForLeadBlockStep {
  viewerCustomer {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForLeadBlockStepQuery, CustomerForLeadBlockStepQueryVariables>;
export const ProgramForLeadBlockStepDocument = gql`
    query programForLeadBlockStep($id: ID!) {
  program(where: {id: $id}) {
    id
    leadRedirect
    provider {
      id
      fullName
    }
    vocation {
      id
      name
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForLeadBlockStepQuery, ProgramForLeadBlockStepQueryVariables>;
export const ProgramForLeadRedirectStepDocument = gql`
    query programForLeadRedirectStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    leadRedirect
    provider {
      id
      fullName
    }
  }
}
    ` as unknown as DocumentNode<ProgramForLeadRedirectStepQuery, ProgramForLeadRedirectStepQueryVariables>;
export const CustomerForMilitaryAffiliationStepDocument = gql`
    query customerForMilitaryAffiliationStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForMilitaryAffiliationStep
  }
}
    ${CustomerForMilitaryAffiliationStepFragmentDoc}` as unknown as DocumentNode<CustomerForMilitaryAffiliationStepQuery, CustomerForMilitaryAffiliationStepQueryVariables>;
export const UpdateCustomerForMilitaryAffiliationStepDocument = gql`
    mutation updateCustomerForMilitaryAffiliationStep($hasMilitaryAffiliation: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {hasMilitaryAffiliation: $hasMilitaryAffiliation}) {
    ...CustomerForMilitaryAffiliationStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForMilitaryAffiliationStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForMilitaryAffiliationStepMutation, UpdateCustomerForMilitaryAffiliationStepMutationVariables>;
export const UpdateCustomerForPhoneStepDocument = gql`
    mutation updateCustomerForPhoneStep($data: CustomerUpdateInput!, $shouldGetTokens: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: $data) {
    id
    user {
      id
      phone
      phoneVerified
      tokens @include(if: $shouldGetTokens) {
        accessToken
        refreshToken
      }
    }
    ...FlowStateUpdateFragment
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForPhoneStepMutation, UpdateCustomerForPhoneStepMutationVariables>;
export const MeForPhoneVerificationStepDocument = gql`
    query meForPhoneVerificationStep {
  me {
    id
    phone
    phoneVerified
  }
}
    ` as unknown as DocumentNode<MeForPhoneVerificationStepQuery, MeForPhoneVerificationStepQueryVariables>;
export const RequestCodeViaPhoneForVerificationDocument = gql`
    mutation requestCodeViaPhoneForVerification($phone: String!, $isMobile: Boolean = true) {
  requestCodeViaPhone(phone: $phone, isMobile: $isMobile)
}
    ` as unknown as DocumentNode<RequestCodeViaPhoneForVerificationMutation, RequestCodeViaPhoneForVerificationMutationVariables>;
export const VerifyPhoneCodeDocument = gql`
    mutation verifyPhoneCode($code: String!, $phone: String!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  verifyPhoneCode(code: $code, phone: $phone) {
    id
    phone
    phoneVerified
    tokens {
      accessToken
      refreshToken
    }
    customer {
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<VerifyPhoneCodeMutation, VerifyPhoneCodeMutationVariables>;
export const ProgramForPreLeadRedirectStepDocument = gql`
    query programForPreLeadRedirectStep($programId: ID!) {
  program(where: {id: $programId}) {
    id
    preLeadRedirect
    preLeadRedirectParams
    provider {
      id
      fullName
    }
  }
}
    ` as unknown as DocumentNode<ProgramForPreLeadRedirectStepQuery, ProgramForPreLeadRedirectStepQueryVariables>;
export const ProgramForCompletedStepDocument = gql`
    query programForCompletedStep($id: ID!) {
  program(where: {id: $id}) {
    id
    leadRedirect
    vocation {
      id
      name
      industry
    }
    provider {
      id
      fullName
      showPostLeadRecommendations
    }
  }
}
    ` as unknown as DocumentNode<ProgramForCompletedStepQuery, ProgramForCompletedStepQueryVariables>;
export const CustomerForCompletedStepDocument = gql`
    query customerForCompletedStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForCompletedStepQuery, CustomerForCompletedStepQueryVariables>;
export const CustomerForRnLicenseStepDocument = gql`
    query customerForRnLicenseStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForRnLicenseStep
  }
}
    ${CustomerForRnLicenseStepFragmentDoc}` as unknown as DocumentNode<CustomerForRnLicenseStepQuery, CustomerForRnLicenseStepQueryVariables>;
export const UpdateCustomerForRnLicenseStepDocument = gql`
    mutation updateCustomerForRnLicenseStep($hasRNLicense: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {hasRNLicense: $hasRNLicense}) {
    ...CustomerForRnLicenseStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForRnLicenseStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForRnLicenseStepMutation, UpdateCustomerForRnLicenseStepMutationVariables>;
export const CreateUserSignInStepDocument = gql`
    mutation createUserSignInStep($data: UserCreateInput!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  createOneUser(data: $data) {
    id
    phone
    phoneVerified
    email
    emailVerified
    customer {
      id
      user {
        id
        nameFirst
        nameLast
        email
        phone
      }
      ...FlowStateUpdateFragment
    }
  }
}
    ${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<CreateUserSignInStepMutation, CreateUserSignInStepMutationVariables>;
export const CustomerForStateRestrictionRejectedStepDocument = gql`
    query customerForStateRestrictionRejectedStep {
  viewerCustomer {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForStateRestrictionRejectedStepQuery, CustomerForStateRestrictionRejectedStepQueryVariables>;
export const ProgramForStateRestrictionRejectedStepDocument = gql`
    query programForStateRestrictionRejectedStep($id: ID!) {
  program(where: {id: $id}) {
    id
    vocation {
      id
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForStateRestrictionRejectedStepQuery, ProgramForStateRestrictionRejectedStepQueryVariables>;
export const CustomerForStudentRejectedStepDocument = gql`
    query customerForStudentRejectedStep {
  viewerCustomer {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForStudentRejectedStepQuery, CustomerForStudentRejectedStepQueryVariables>;
export const ProgramForStudentRejectedStepDocument = gql`
    query programForStudentRejectedStep($id: ID!) {
  program(where: {id: $id}) {
    id
    provider {
      id
      fullName
    }
    vocation {
      id
      name
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForStudentRejectedStepQuery, ProgramForStudentRejectedStepQueryVariables>;
export const CustomerForUsCitizenshipStepDocument = gql`
    query customerForUsCitizenshipStep($customerId: ID!) {
  customer(where: {id: $customerId}) {
    ...CustomerForUsCitizenshipStep
  }
}
    ${CustomerForUsCitizenshipStepFragmentDoc}` as unknown as DocumentNode<CustomerForUsCitizenshipStepQuery, CustomerForUsCitizenshipStepQueryVariables>;
export const UpdateCustomerForUsCitizenshipStepDocument = gql`
    mutation updateCustomerForUsCitizenshipStep($isUsCitizen: Boolean!, $programFlow: Boolean!, $programId: ID, $questionnaireFlow: Boolean!, $skipperFlow: Boolean!, $flowIntent: FlowIntent, $signInFlow: Boolean!) {
  updateViewerCustomer(data: {isUsCitizen: $isUsCitizen}) {
    ...CustomerForUsCitizenshipStep
    ...FlowStateUpdateFragment
  }
}
    ${CustomerForUsCitizenshipStepFragmentDoc}
${FlowStateUpdateFragmentFragmentDoc}` as unknown as DocumentNode<UpdateCustomerForUsCitizenshipStepMutation, UpdateCustomerForUsCitizenshipStepMutationVariables>;
export const CustomerForZipCodeRestrictionStepDocument = gql`
    query customerForZipCodeRestrictionStep {
  viewerCustomer {
    id
    detailsMap {
      id
      address {
        id
        zip
      }
    }
  }
}
    ` as unknown as DocumentNode<CustomerForZipCodeRestrictionStepQuery, CustomerForZipCodeRestrictionStepQueryVariables>;
export const ProgramForZipCodeRestrictionStepDocument = gql`
    query programForZipCodeRestrictionStep($id: ID!) {
  program(where: {id: $id}) {
    id
    vocation {
      id
      industry
    }
  }
}
    ` as unknown as DocumentNode<ProgramForZipCodeRestrictionStepQuery, ProgramForZipCodeRestrictionStepQueryVariables>;